// extracted by mini-css-extract-plugin
module.exports = {"blur":"styles_blur__215HE","centered-blur":"styles_centered-blur__sRFId"};